import { routes as routesV2 } from './routes-v2';

export const routes = {
  home: '/',
  accessDenied: '/403',
  beta: routesV2,
  blog: 'https://blog.goodfynd.com',
  careers: 'https://www.goodfynd.com/careers',
  docs: '/docs',
  maintenance: '/maintenance',
  notFound: '/404',
  unauthorized: '/401',
  account: {
    callback: '/auth/callback',
    home: 'https://www.goodfynd.com/profile',
    signIn: '/auth/login',
    logout: '/auth/logout',
    profile: '/auth/profile',
    signUp: '/auth/signup',
    unverified: '/auth/unverified',
    orders: 'https://order.goodfynd.com/profile/order-history',
  },
  apps: {
    android:
      'https://play.google.com/store/apps/details?id=com.goodfynd.trucks',
    ios: 'https://apps.apple.com/us/app/goodfynd/id1402316922?ls=1',
  },
  dashboard: {
    add: '/add',
    edit: '/dashboard/:id/edit',
    home: '/dashboard',
    overview: '/dashboard/:id/overview',
    account: {
      billing: '/dashboard/:id/account/billing',
      hardware: '/dashboard/:id/account/hardware',
      info: {
        home: '/dashboard/:id/account/info',
        licenses: '/dashboard/:id/account/info/licenses',
        payouts: '/dashboard/:id/account/info/payouts',
        personnel: '/dashboard/:id/account/info/personnel',
      },
      subscriptions: '/dashboard/:id/account/subscriptions',
    },
    events: {
      home: '/dashboard/:id/events',
      cateringLeads: '/dashboard/:id/catering-leads',
      leads: '/dashboard/:id/event-leads',
      venueLeads: '/dashboard/:id/venue-leads',
      awaitingConfirmation: '/dashboard/:id/events/awaiting-confirmation',
      confirmed: '/dashboard/:id/events/confirmed',
      interest: '/dashboard/:id/events/interest',
      rejected: '/dashboard/:id/events/rejected',
    },
    invoicing: {
      invoices: '/dashboard/:id/invoices/all',
      quotes: '/dashboard/:id/invoices/quotes',
    },
    products: {
      home: '/dashboard/:id/products',
      addItem: '/dashboard/:id/products/add',
      editItem: '/dashboard/:id/products/edit/:itemId',
      items: '/dashboard/:id/products/items',
      itemOptions: '/dashboard/:id/products/options',
      categories: '/dashboard/:id/products/categories',
      menus: '/dashboard/:id/products/menus',
      globalItems: '/dashboard/:id/products/items/global',
    },
    promos: {
      home: '/dashboard/:id/promos',
    },
    reports: {
      home: '/dashboard/:id/reports',
      advanced: '/dashboard/:id/reports/advanced',
      payouts: '/dashboard/:id/reports/payouts',
      transactions: {
        invoices: '/dashboard/:id/reports/transactions/invoices',
        items: '/dashboard/:id/reports/transactions/items',
        tickets: '/dashboard/:id/reports/transactions',
      },
    },
    schedule: {
      flyers: '/dashboard/:id/schedule/flyers',
      googleSync: '/dashboard/:id/schedule/google-sync',
      home: '/dashboard/:id/schedule/list',
      map: '/dashboard/:id/schedule/map',
    },
    settings: {
      ordering: '/dashboard/:id/settings/ordering',
      orderingSettingsWizardPath: '/dashboard/ordering-settings-wizard',
      website: '/dashboard/:id/settings/website',
    },
    transactions: {
      home: '/dashboard/:id/orders',
      all: '/dashboard/:id/orders/all',
      online: '/dashboard/:id/orders/online',
      // next30Mins: '/dashboard/:id/orders/next30min',
      // today: '/dashboard/:id/orders/today',
      // tomorrow: '/dashboard/:id/orders/tomorrow',
      walkups: '/dashboard/:id/orders/walk-ups',
    },
  },
  events: {
    details: '/events/details/:id',
  },
  help: {
    home: '/help',
    chat: '/chat',
  },
  legal: {
    fulfillment: 'https://www.goodfynd.com/legal/fulfillment',
    privacy: 'https://www.goodfynd.com/legal/privacy',
    terms: 'https://www.goodfynd.com/legal/terms',
  },
  organization: {
    edit: '/organization/:organizationId/edit',
    events: '/organization/:organizationId/events',
    overview: '/organization/:organizationId/overview',
    promos: '/organization/:organizationId/promos',
    radar: '/organization/:organizationId/radar',
    employee: {
      add: '/organization/:organizationId/employee/add',
      edit: '/organization/:organizationId/employee/edit/:id',
    },
    info: {
      home: '/organization/:organizationId/info',
      addOns: '/organization/:organizationId/info/add-ons',
      payments: '/organization/:organizationId/info/payments',
      payouts: '/organization/:organizationId/info/payouts',
      personnel: '/organization/:organizationId/info/personnel',
      structure: '/organization/:organizationId/info/structure',
      territories: '/organization/:organizationId/info/territories',
    },
    invoicing: {
      invoices: '/organization/:organizationId/invoices/all',
      quotes: '/organization/:organizationId/invoices/quotes',
    },
    manage: {
      organizations: '/organization/:organizationId/manage/organizations',
      staff: '/organization/:organizationId/manage/staff',
      territories: '/organization/:organizationId/manage/territories',
      vendors: '/organization/:organizationId/manage/vendors',
    },
    products: {
      items: '/organization/:organizationId/products/items',
      options: '/organization/:organizationId/products/options',
      categories: '/organization/:organizationId/products/categories',
      menu: '/organization/:organizationId/products/menus',
      addItem: '/organization/:organizationId/products/add',
      editItem: '/organization/:organizationId/products/edit/:id',
    },
    reports: {
      home: '/organization/:organizationId/reports',
      advanced: '/organization/:organizationId/reports/advanced',
      payouts: '/organization/:organizationId/reports/payouts',
      transactions: {
        invoices: '/organization/:organizationId/reports/transactions/invoices',
        items: '/organization/:organizationId/reports/transactions/items',
        tickets: '/organization/:organizationId/reports/transactions',
      },
    },
    schedule: {
      home: '/organization/:organizationId/schedule/list',
      map: '/organization/:organizationId/schedule/map',
    },
    settings: {
      account: '/organization/:organizationId/settings/account',
      ordering: '/organization/:organizationId/settings/ordering',
    },
    support: {
      home: '/organization/:organizationId/support',
    },
    transactions: {
      home: '/organization/:organizationId/orders',
      all: '/organization/:organizationId/orders/all',
      online: '/organization/:organizationId/orders/online',
      walkups: '/organization/:organizationId/orders/walk-ups',
    },
  },
  search: {
    products: 'https://www.goodfynd.com/search/products',
    vendors: 'https://www.goodfynd.com/search/vendors',
  },
  social: {
    facebook: 'https://www.facebook.com/goodfynd',
    instagram: 'https://www.instagram.com/goodfynd/',
    linkedIn: 'https://www.linkedin.com/company/goodfynd',
    twitter: 'https://twitter.com/goodfynd',
  },
  stripe: {
    onboarding: '/dashboard/:id/account/info/payouts',
  },
  support: {
    home: '/dashboard/:id/support',
  },
};

export const externalRoutes = {
  events: {
    consumerLanding: 'https://www.goodfynd.com/events',
  },
  vendors: {
    details: 'https://www.goodfynd.com/vendors/:id',
  },
};

export default routes;
